import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Constants/Urls'
import { BgEventsLogModel } from 'Pages/logs'

export const bgEventsRequestStatusApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BgEventsLogModel>>(
			urls.logs.bg_events_request_status,
			{
				params,
			}
		)
		return res.data
	},
}
